import { useFirebaseAuth } from "../firebase/auth-context"

/**
 * Custom hook that returns the current Firebase auth token.
 * Throws an error if used outside of authenticated context.
 */
export function useAuthToken(): string {
  const { token, status } = useFirebaseAuth()
  
  if (status !== "signed-in" || !token) {
    throw new Error("useAuthToken must be used within an authenticated context")
  }
  
  return token
}
